import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import api from "@/lib/api";

export default function DemoBanner() {
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    api
      .get("/settings/access")
      .then(({ data }) => setClosed(!data.signup_enabled))
      .catch(() => {});
  }, []);

  if (!closed) return null;

  return (
    <div
      data-testid="demo-banner"
      className="w-full bg-amber-400 text-slate-900 text-xs sm:text-sm font-medium py-1.5 px-4 flex items-center justify-center gap-2"
    >
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <span>Demonstration site — new signups are disabled. This portal is for preview purposes only.</span>
    </div>
  );
}
